import React from 'react';
import { arrayOf, string, number, shape } from 'prop-types';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import styles from './article-section.module.scss';

const PROJECT_GUIDE = 'ah';
const BUYING_GUIDE = 'ab';
const Dropdown = ({ sections, articleType }) => {
  if (articleType !== PROJECT_GUIDE && articleType !== BUYING_GUIDE) return null;
  if (!Array.isArray(sections) || !sections.length) return null;

  const sectionLinks = sections.map(({ name, stepNumber }, index) => (
    <li key={index} className={styles['dropdown-item']}>
      <AnchorLink href={`#step-${stepNumber}`}>{name}</AnchorLink>
    </li>
  ));

  return (
    <nav data-testid="dropdown" className={styles.dropdown}>
      <div className={styles['dropdown-title']}>Jump to Specific Section</div>
      <div className={styles['content-wrapper']}>
        <ul className={styles['dropdown-list']}>
          {sectionLinks}
        </ul>
      </div>
    </nav>
  );
};

Dropdown.propTypes = {
  sections: arrayOf(shape({
    name: string,
    stepNumber: number
  })).isRequired,
  articleType: string
};

Dropdown.defaultProps = {
  articleType: ''
};

export { Dropdown };
